import './MenuContainer.scss';
import React, { useEffect, useState } from 'react';
import Menu from '../menu/Menu';
import { generalStore } from '../../store';
import { useLocation } from 'react-router';
import { ROUTES } from '../../js/_constants';
import { useTranslation } from 'react-i18next';

const MenuContainer = () => {
    const { t } = useTranslation();

    const pathname = useLocation().pathname;
    const [pageTitle, setPageTitle] = useState('');
    const { pageName } = generalStore();

    useEffect(() => {
        switch (pathname) {
            case ROUTES.DASHBOARD: {
                setPageTitle('Dashboard');
                break;
            }
            case ROUTES.MEDIA_LIBRARY: {
                setPageTitle('page_name_mediaLibrary');
                break;
            }
            case ROUTES.DEVICES: {
                setPageTitle('page_name_devices');
                break;
            }
            case ROUTES.ONBOARDING: {
                setPageTitle('page_name_tutorial');
                break;
            }
            case ROUTES.PLAYLISTS: {
                setPageTitle('page_name_playlists');
                break;
            }
            case ROUTES.SUPPORT: {
                setPageTitle('support_title');
                break;
            }
            case ROUTES.PROFILE: {
                setPageTitle('page_name_profile');
                break;
            }
            case ROUTES.DEALERSHIPS: {
                setPageTitle('page_name_dealerships');
                break;
            }
            case ROUTES.WELCOME_SCREEN_PAGE: {
                setPageTitle('Welcome Screen');
                break;
            }
            default: {
                setPageTitle('');
                break;
            }
        }
    }, [pathname]);

    return (
        <div className="b-menu-container">
            <div className="aligned-right">
                <h1 className="page-title" data-testid="page-title">{t(pageTitle) || pageName}</h1>
            </div>
            <Menu />
        </div>
    );
};

export default (MenuContainer);
